'use client'

import Link from "next/link";
import { Video } from "lucide-react";
import LoginButton from "../../../../components/loginInLogOutButton";
import { usePathname } from "next/navigation";
import { useEffect } from "react";


export default function Header() {
    const pathname = usePathname()

    

    if (pathname === '/script/result'){
        return(
            <header className="sticky top-0 z-50 w-full bg-black text-white">
                <p className="text-center font-bold"> SCRIPT RESULT</p>
             </header>
        )
    }{
        return (
            <header className="sticky top-0 z-50 w-full bg-black text-gray-100 shadow-lg">
                <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex h-16 items-center justify-between">
                    <Link href="/" className="flex items-center space-x-2">
                        <Video className="h-6 w-6" />
                        <span className="font-bold text-xl">ICAT</span>
                    </Link>
    
    
                    <div className="hidden md:flex flex-1 justify-center space-x-8">
                        <Link href="/" className="text-lg font-medium transition-transform duration-200 hover:scale-110 hover:text-white">
                            Home
                        </Link>
                        <Link href="/pricing" className="text-lg font-medium transition-transform duration-200 hover:scale-110 hover:text-white">
                            Pricing
                        </Link>
                    </div>
                    <LoginButton />
                </nav>
            </header>
        );
    }


}
